import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { etiquetaDeJornada, jornadasDeRueda } from "./jornadas";
import { FICHAS_POR_HOJA, fichasEnBlanco, generarFichasArbitros, partidosParaFichas } from "./fichasArbitros";
import { toastBigError } from "components/utils/toasts";

// Pregunta de qué jornada de la rueda salen las fichas de árbitros. Van todas en
// el mismo PDF, 6 por hoja: primero una ficha por partido (menos los que se
// dieron por walk-over) y después, en blanco, las que falten para completar la
// última hoja.
export default function FichasArbitrosModal({ isOpen, round, torneoNombre, torneoAno, teams = [], onClose }) {
  const jornadas = React.useMemo(() => jornadasDeRueda(round), [round]);
  const [dia, setDia] = React.useState("");
  const [generando, setGenerando] = React.useState(false);

  // Al abrir se propone la jornada más reciente.
  React.useEffect(() => {
    if (isOpen) setDia(jornadas.length ? jornadas[0].dia : "");
  }, [isOpen, jornadas]);

  const jornada = jornadas.find((j) => j.dia === dia) || null;
  const partidos = partidosParaFichas((jornada && jornada.fechas) || []);
  const enBlanco = fichasEnBlanco(partidos.length);
  const hojas = (partidos.length + enBlanco) / FICHAS_POR_HOJA;

  const generar = async () => {
    if (!jornada) return;
    setGenerando(true);
    try {
      await generarFichasArbitros({
        fechas: jornada.fechas,
        numero: jornada.numero,
        dia: jornada.dia,
        torneoNombre,
        torneoAno,
        teams,
      });
      onClose();
    } catch (ex) {
      toastBigError("No se pudieron generar las fichas", "Intentá de nuevo en un momento.");
    } finally {
      setGenerando(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered>
      <ModalHeader toggle={onClose}>Fichas Árbitros</ModalHeader>
      <ModalBody>
        {jornadas.length === 0 ? (
          <p className="text-muted mb-0" style={{ fontSize: "0.875rem" }}>
            Las zonas de esta rueda todavía no tienen fechas con día asignado.
          </p>
        ) : (
          <React.Fragment>
            <div className="form-group">
              <label className="font-weight-bold" style={{ fontSize: "0.8125rem" }}>
                Fecha
              </label>
              <select className="form-control" value={dia} onChange={(e) => setDia(e.target.value)}>
                {jornadas.map((j) => (
                  <option key={j.dia} value={j.dia}>
                    {etiquetaDeJornada(j)}
                  </option>
                ))}
              </select>
            </div>

            <p className="text-muted mb-0" style={{ fontSize: "0.8125rem" }}>
              {partidos.length === 0
                ? "Esa fecha todavía no tiene partidos para arbitrar."
                : partidos.length +
                  " fichas de partidos (los walk-over no llevan)" +
                  (enBlanco ? " y " + enBlanco + " en blanco para completar la hoja" : "") +
                  ": " +
                  hojas +
                  (hojas === 1 ? " hoja." : " hojas.")}
            </p>
          </React.Fragment>
        )}
      </ModalBody>
      <ModalFooter>
        <Button className="btn-arhock btn-sm my-0" style={{ opacity: 0.55 }} onClick={onClose}>
          Cancelar
        </Button>
        <Button
          className="btn-arhock btn-sm my-0"
          onClick={generar}
          disabled={partidos.length === 0 || generando}
        >
          {generando ? "Generando..." : "Generar"}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
